<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 8.92857L9.99747 6.78571M9.99747 6.78571V13.2143M9.99747 6.78571L12 8.92857M10 17.5H3C1.89543 17.5 1 16.6046 1 15.5V4.5C1 3.39543 1.89543 2.5 3 2.5H17C18.1046 2.5 19 3.39543 19 4.5V15.5C19 16.6046 18.1046 17.5 17 17.5H10Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>
<style lang="scss" scoped>
svg {
  flex-shrink: 0;
}
</style>
